import { csrfFetch } from '../utils/csrfFetch';
import { loadCompanies } from './companies';
import { loadAccounts } from './accounts';
import { loadUsers } from './users';
import { loadTrucks } from './trucks';
import { loadTrailers } from './trailers';
import { loadBuildings } from './buildings';
import { loadYards } from './yards';

export const fetchAllAdminData = () => async (dispatch) => {
  try {
    const response = await csrfFetch('/api/admin/', {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.ok) {
      const data = await response.json();

      dispatch(loadCompanies(data.companies));
      dispatch(loadAccounts(data.accounts));
      dispatch(loadUsers(data.users));
      dispatch(loadTrucks(data.trucks));
      dispatch(loadTrailers(data.trailers));
      dispatch(loadBuildings(data.buildings));
      dispatch(loadYards(data.yards));
    }
  } catch (error) {
    console.error('Error fetching admin data:', error);
  }
};
